/**
 * Inventory Service API
 * This is the inventory-service API generated by springdocs - a library for OpenAPI 3 with spring boot.
 *
 * The version of the OpenAPI document: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CartItemDto { 
    code?: string;
    name?: string;
    brand?: string;
    description?: string;
    image?: string;
    price?: number;
    qty?: number;
}

